// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"a16d48af","136":"82ecb9ee","328":"93ffd33b","453":"ffd60a75","661":"5184ff2e","748":"de24c830"}[chunkId] + ".chunk.js";
};